// extracted by mini-css-extract-plugin
export var fadeIn = "_d2-1";
export var modalContent = "_d2-3";
export var overlay = "_d2-0";
export var popoverContent = "_d2-2";
export var results = "_d2-5";
export var searchInputWrapper = "_d2-4";